import { render, staticRenderFns } from "./LmFooter.vue?vue&type=template&id=0553b5f6&scoped=true&"
var script = {}
import style0 from "./LmFooter.vue?vue&type=style&index=0&id=0553b5f6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553b5f6",
  null
  
)

export default component.exports